import { useState, useEffect } from 'react'
import {isMobile} from 'react-device-detect'

export const useScreenOrientation = () => {
    const [orientation, setOrientation] = useState(window.screen.orientation.angle)

    const handleOrientationChange = () => {
        setOrientation(window.screen.orientation.angle)
    };

    useEffect(() => {
        window.screen.orientation.addEventListener('change', handleOrientationChange)

        return () => {
            window.screen.orientation.removeEventListener('change', handleOrientationChange)}
    }, [])

    return orientation
};


export function getPlatform(){
    if (isMobile === true) return 'mobile'
    else return 'desktop'
}
